
import { http } from "@/http/http.js";


export function statisticInfo(params) {
    return http.post("/web/pipeManage/statisticInfo", params);
}

export function pipenetQueryPage(params) {
    return http.post("/web/wellqrcode/queryPage", params);
}

export function downloadWellQrcode(params) {
    return http.postUpload("/web/wellqrcode/downloadWellQrcode", params);
}


export function generateWellQrcode(params) {
    return http.post("/web/wellqrcode/generateWellQrcode", params);
}


export function getLineByPageDto(params) {
    return http.post("/web/pipeManage/getLineByPageDto", params);
}

export function uploadExcelLine(params) {
    return http.postFile("/web/pipeManage/uploadExcel/line", "",params);
}

export function exportExcelLine(params) {
    return http.postUpload("/web/pipeManage/exportExcel/line",params);
}

export function getSegmentsByPageDto(params) {
    return http.post("/web/pipeManage/getSegmentsByPageDto",params);
}

export function createPipeSegments(params) {
    return http.post("/web/pipeManage/createPipeSegments",params);
}

export function blockOrBurstLine(params) {
    return http.post("/web/pipeManage/update/line/blockOrBurst",params);
}

//井
export function getWellByPageDto(params) {
    return http.post("/web/pipeManage/getWellByPageDto", params);
}

export function uploadExcelWell(params) {
    return http.postFile("/web/pipeManage/uploadExcel/well", "",params);
}

export function exportExcelwell(params) {
    return http.postUpload("/web/pipeManage/exportExcel/well",params);
}


export function blockOrBurst(params) {
    return http.post("/web/pipeManage/update/well/blockOrBurst",params);
}
